import { useMutation, useQueryClient } from '@tanstack/react-query';
import { planPaymentRequestApi } from '@src/apis/admin';
import type { PaymentRequestSummaryResponseModel } from '@uniquegood/realworld-admin-interface';

/**
 * 결제 요청 링크를 재생성하는 mutation
 *
 * @description
 * - 진행 중인 결제 요청의 링크를 재생성합니다.
 * - PlanPaymentRequestApi.updatePaymentRequestLink를 사용하여 실제 API를 호출합니다.
 * - 성공 시 진행중인 결제 요청 쿼리를 업데이트하여 데이터를 갱신합니다.
 */
export const useUpdatePaymentRequestLink = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updatePaymentRequestLink'],
        mutationFn: async ({
            channelId,
            paymentRequestId,
        }: {
            channelId: string;
            paymentRequestId: string;
        }) => {
            const { data } = await planPaymentRequestApi.updatePaymentRequestLink(
                channelId,
                paymentRequestId,
                undefined // x-rwd-api-version은 default value 사용
            );

            return { data: data.data, channelId, paymentRequestId };
        },
        onSuccess: (response) => {
            // 진행중인 결제 요청 쿼리 데이터를 직접 업데이트
            queryClient.setQueryData<PaymentRequestSummaryResponseModel | null>(
                ['current-payment-request', response.channelId],
                response.data ?? null
            );
            
            // 관련 쿼리 무효화하여 재조회 유도
            queryClient.invalidateQueries({ queryKey: ['current-payment-request', response.channelId] });
        },
    });
};

